import { render, staticRenderFns } from "./PageSubscriptionLevels.vue?vue&type=template&id=71e28c84&"
import script from "./PageSubscriptionLevels.vue?vue&type=script&lang=ts&"
export * from "./PageSubscriptionLevels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports